import firebase from "firebase";
//import { request } from 'framework7';
import { f7 } from "framework7-vue";
import appbar from "framework7-vue/components/appbar";
//import { request } from 'framework7';
import Framework7 from 'framework7/framework7.esm.bundle.js';
//import { app } from "framework7-vue";
const AuthModule = {
  state: {
    user: [],
    upload_button: false,
    app_db_version: null,
    app_version: null,
    signed_in: false,
    signed_up: false,
    valid_inputs: true,
    show_resend_email: false,
    photo_url: null,
    display_name: null,
    user_location: null,
    genderSearch: null,
    profile_message: null,
    total_message: null,
    pageStatus: true
  },
  getters: {

    pageStatus: state => state.pageStatus,
    user: state => state.user,
    upload_button: state => state.upload_button,
    genderSearch: state => state.genderSearch,
    app_version: state => state.app_version,
    app_db_version: state => state.app_db_version,
    valid_inputs: state => state.valid_inputs,
    signed_in: state => state.signed_in,
    signed_up: state => state.signed_up,
    show_resend_email: state => state.show_resend_email,
    photo_url: state => state.photo_url,
    display_name: state => state.display_name,
    user_location: state => state.user_location,
    profile_message: state => state.profile_message,
    total_message: state => state.total_message
  },
  mutations: {

    setUser(state, payload) {
      //console.log("mutatiom", payload)
      state.user = payload;
    },
    setPageStatus(state, payload) {
      state.pageStatus = payload;
    },
    setUploadButton(state, payload) {
      state.upload_button = payload;
    },
    setGenderSearch(state, payload) {
      state.genderSearch = payload;
    },
    setAppVersion(state, payload) {
      state.app_version = payload;
    },
    setAppDbVersion(state, payload) {
      state.app_db_version = payload;
    },
    setValidInputs(state, payload) {
      state.valid_inputs = payload;
    },

    setSignedIn(state, payload) {

      state.signed_in = payload;
    },
    setSignedUp(state, payload) {
      state.signed_up = payload;
    },
    setShowResendEmail(state, payload) {
      state.show_resend_email = payload;
    },
    setPhotoURL(state, payload) {
      state.photo_url = payload;
    },
    setDisplayName(state, payload) {
      state.display_name = payload;
    },
    setUserLocation(state, payload) {
      state.user_location = payload;
    },
    setProfileMessage(state, payload) {
      state.profile_message = payload;
    },
    setTotalMessage(state, payload) {
      state.total_message = payload;
    }
  },
  actions: {


    checkConnection({ }) {
      //console.log("in the checkroutine")
      var promise = new Promise((resolve, reject) => {
        var networkState = navigator.connection.type;

        var states = {};
        states[Connection.UNKNOWN] = "Unknown connection";
        states[Connection.ETHERNET] = "Ethernet connection";
        states[Connection.WIFI] = "WiFi connection";
        states[Connection.CELL_2G] = "Cell 2G connection";
        states[Connection.CELL_3G] = "Cell 3G connection";
        states[Connection.CELL_4G] = "Cell 4G connection";
        states[Connection.CELL] = "Cell generic connection";
        states[Connection.NONE] = "No network connection";
        if (states[networkState] == "No network connection") {
          resolve("offline")
        } else {
          resolve("online")
        }
      }).catch(err => {
        //console.log("check connection error", err)
        reject(err)
      })
      return promise

    },

    getAppDbVersion({ commit },) {


      var promise = new Promise((resolve, reject) => {
        var payload = {}
        payload.domain = "misscomely.com";
        var postData = payload

        Framework7.request.post(
          "https://chatme24.com/penpal/penpalgetappversion.php",
          postData,
          function (data) {

            // console.log("setAppDbVersion", data)
            commit("setAppDbVersion", data);
            resolve(data)

          }
        )

      })
      return promise

    },
    getAppVersion({ commit },) {

      // commit("setAppVersion",  "Android");
      //  console.log("here getAppVersion")
      if (getOS() == "Android") {
        commit("setAppVersion", "Android");
      }

      if (getOS() == "iOS") {
        commit("setAppVersion", "iOS");
      }

      //if ((getOS() != "Android") && (getOS() == "iOS") ){
      //commit("setAppVersion",  "Unknown");
      // }

    },

    resetVerifyInputs({ commit },) {
      commit("setValidInputs", true);
    },

    verifyInputs({ commit }, payload) {
      commit("setValidInputs", false);
      commit("setAlertMessage", payload);
    },

    rerouteuser({ commit }) {
      commit("setSignedIn", false);
      commit("setAlertMessage", "Please verify with your email");
      commit("setShowResendEmail", true)
    },
    async signInMySQL({ commit, dispatch }, payload) {


      var postData = {
        email: payload.email,
        password: payload.password,
        domain: "misscomely.com"
      };



      // const app = this.$f7;
      Framework7.request.post(
        "https://chatme24.com/penpal/loginpenpal.php",
        postData,
        async function (data) {
          //console.log(data)
          var obj = JSON.parse(data);

          //  console.log("response", obj[0].response);
          // console.log("response", obj[0].email);

          var postData2 = {
            email: obj[0].email,
            domain: "misscomely.com"
          };


          if (obj[0].response == "0") {
            // commit("setAlertMessage", `Welcome ${user.displayName}`);

            //get User Details
            let response = await dispatch('getUserPersonalDetails', postData2);
            commit("setAlertMessage", `Welcome ${obj[0].name}`);
            commit("setSignedIn", true);
            commit("setShowResendEmail", false)
            // commit("setDisplayName", "Nosa")
          }

          if (obj[0].response == "1") {
            commit(
              "setAlertMessage",
              "Check your email and verify your account."
            );
            commit("setShowResendEmail", true)
          }

          if (obj[0].response == "2") {
            commit(
              "setAlertMessage",
              "User not found. Kindly create a new Account"
            );
          }

          if (obj[0].response == "3") {
            commit(
              "setAlertMessage",
              "Incorret login details. Please try again"
            );
          }

          if (obj[0].response == "4") {
            commit(
              "setAlertMessage",
              "Your Account has been banned. Contact Admin"
            );
          }

          if (obj[0].response == "5") {
            commit(
              "setAlertMessage",
              "This account was deleted by you. Contact support if you want it restored"
            );
          }
          if (obj[0].response == "-1") {
            commit(
              "setAlertMessage",
              "Database Error! Please try again or contact Admin"
            );
          }

        }, function (err) {
          commit(
            "setAlertMessage",
            "Network Issue. Please check your internet connection and  try again"
          );
        }

      )


    },




    getUserPersonalDetails({ commit }, postData) {
      //console.log("user Email", postData);
      var promise = new Promise((resolve, reject) => {
        Framework7.request.post(
          "https://chatme24.com/penpal/userdetailspenpal.php",
          postData,
          async function (data) {
            //var obj = JSON.parse(data);
            //  console.log("User details data", data);
            var obj = JSON.parse(data);
            commit("setUser", obj)
            commit('setUserDetails', obj)
            resolve('0')
            // console.log(user.name)
            //console.log(self.todayblogger.name);
          }
        );
      })
      return promise
    },


    async signIn({ commit, dispatch }, payload) {
      //console.log("firebase login auth")

      //return

      var userStatus = '0'
      var oldUser = "0"
      var errorMessage = ""
      await firebase
        .auth()
        .signInWithEmailAndPassword(payload.email, payload.password)
        .then(user => {
          console.log("check check")
          const self = this;
          //f7.dialog.preloader("Logging you in. <br>Please Wait...");
          //logined in
          firebase.auth().onAuthStateChanged(function (user) {
            if (user != null) {
              //  console.log('user in action', user)
              if (user.emailVerified) {
                // console.log("200 Is this done all times")
                //console.log(user.displayName)
                f7.dialog.close();
                commit("setAlertMessage", `Welcome ${user.displayName}`);
                //console.log('verified')
                commit("setSignedIn", true);
                commit("setShowResendEmail", false)
                // commit("setUserLocation",user.location)
                //console.log("authmodule",user.location)   
                var userId = firebase.auth().currentUser.uid

                firebase.database().ref('users/' + userId).update({
                  userStatus: "online"
                });
                //const app = this.$f7;
                //this.$f7router.navigate("/home")
                //commit("setAlertMessage", `Welcome ${user.displayName}`);
              } else {
                // No user is signed in.
                //console.log('not verified')
                f7.dialog.close();
                commit("setSignedIn", false);
                commit("setAlertMessage", "Please verify with your email");
                commit("setShowResendEmail", true)
              }
            } else {
              // console.log("nosa here@@@")
              f7.dialog.close();
              return;
            }

          });
        })
        .catch(function (error) {
          oldUser = "1"
          //check if an old user
          errorMessage = error.message
          console.log("Old user", errorMessage)

        });
      console.log("continue", oldUser)
      //return
      if (oldUser == "1") {
        // console.log("continue2", oldUser)
        var payload2 = {}
        payload2.email = payload.email
        payload2.password = payload.password


        //load preloader 

        var userInfo = await dispatch("checkUserExistsAmerica", payload2)
        // console.log("userinfor from checkuserExists..", JSON.stringify(userInfo))

        if (userInfo != null && userInfo.length > 0) {
          userStatus = "1"
          // console.log("userInfo", userInfo)
          //"QyxCTA8OULg1NTfSoM6c2jtVkhJ3"
          var newUserId = await dispatch("signUpOldUser", userInfo)
          //console.log("newUserId", newUserId)
          await dispatch("deleteOldAccount", newUserId)

          //commit("setAlertMessage", "Old User Process further");

        } else {

          commit("setAlertMessage", errorMessage);
          //console.log(errorMessage + " " + JSON.stringify(userInfo))


        }


      }
      return userStatus
    },

    signUp({ commit, dispatch }, payload) {
      //console.log("rhoda",payload.country)
      //console.log("nosa",payload.phonenumber)
      var myCountry = payload.country
      // myCountry = myCountry.replace(" ", "");
      myCountry = myCountry.replace(".", "");
      myCountry = myCountry.replace("#", "");
      myCountry = myCountry.replace("$", "");
      myCountry = myCountry.replace("[", "");
      myCountry = myCountry.replace("]", "");
      //payload.country = myCountry

      if (payload.email != null && payload.password != null) {

        firebase
          .auth()
          .createUserWithEmailAndPassword(payload.email, payload.password)
          .then(data => {
            firebase
              .database()
              .ref("users")
              .child(data.user.uid)
              .set({
                uid: data.user.uid,
                country: myCountry,
                name: payload.name,
                email: payload.email,
                gender: payload.gender,
                phonenumber: payload.phonenumber,
                location: payload.location,
                profileMessage: payload.profileMessage,
                birthDate: payload.dateofbirth,
                emailverified: false,
                photo_url: payload.photoURL,
                userType: payload.userType,
                userStatus: payload.userStatus,
                lastSeen: payload.lastSeen,
                userToken: payload.userToken,
                dateCreated: payload.lastSeen,
                payout: "0",
                photoUpload: payload.photoUpload,
                pageSize: 3,
                serviceExpiration: payload.lastSeen,

              });
            let newuser = data.user;
            newuser
              .updateProfile({
                displayName: payload.name,
                photoURL: payload.photoURL
              })
              .then(() => {
                dispatch("sendVerification");
                commit("setSignedUp", true);
                //console.log("updated profile");
              })
              .catch(err => {
                //  console.log(err.message);
                commit("setAlertMessage", err.message);
              });
          })
          .catch(err => {
            //console.log(err.message);
            commit("setAlertMessage", err.message);
          });

      }
    },



    signUpOldUser({ commit, dispatch }, payload) {
      var newString = {}
      //newString = JSON.stringify(payload)
      //console.log("phonenumber", newString.phonenumber)
      //console.log("rhoda", JSON.stringify(payload))
      // console.log("nosa phonenumber", payload[0].phonenumber)


      //console.log("james email", payload[0].email)
      // console.log("nosa password", payload[0].password)
      //return
      // var myCountry = payload[0].country
      // myCountry = myCountry.replace(" ", "");
      // myCountry = myCountry.replace(".", "");
      // myCountry = myCountry.replace("#", "");
      //myCountry = myCountry.replace("$", "");
      //myCountry = myCountry.replace("[", "");
      // myCountry = myCountry.replace("]", "");
      //payload.country = myCountry

      if (payload[0].email != null && payload[0].password != null) {
        //console.log("nosa am here ok 1 and 1", payload[0].country)
        //return
        firebase
          .auth()
          .createUserWithEmailAndPassword(payload[0].email, payload[0].password)
          .then(data => {
            //console.log("nosa am here o")
            firebase
              .database()
              .ref("users")
              .child(data.user.uid)
              .set({
                uid: data.user.uid,
                photoUpload: payload[0].photoUpload,
                country: payload[0].country,
                name: payload[0].name,
                email: payload[0].email,
                gender: payload[0].gender,
                phonenumber: payload[0].phonenumber,
                location: payload[0].location,
                profileMessage: payload[0].profileMessage,
                birthDate: payload[0].birthDate,
                emailverified: payload[0].emailverified,
                photo_url: payload[0].photo_url,
                userType: payload[0].userType,
                userStatus: payload[0].userStatus,
                lastSeen: payload[0].lastSeen,
                userToken: payload[0].userToken,
                dateCreated: payload[0].lastSeen,
                payout: payload[0].payout,
                pageSize: payload[0].pageSize,
                serviceExpiration: payload[0].serviceExpiration,

              });
            let newuser = data.user;
            newuser
              .updateProfile({
                displayName: payload[0].name,
                photoURL: payload[0].photoURL
              })
              .then(() => {
                dispatch("sendVerification");
                commit("setSignedUp", true);
                console.log("updated profile", payload[0].email);
              })
              .catch(err => {
                console.log(err.message);
                commit("setAlertMessage", err.message);
              });
          })
          .catch(err => {
            console.log(err.message);
            commit("setAlertMessage", err.message);
          });
        return payload[0].uid
      } else {
        console.log("parameters are null")
      }
    },


    signOutPlus({ commit }) {

      //console.log("sign out")
      commit("setShowResendEmail", true)
      commit("setAlertMessage", 'Profile Picture uploaded successfully. Please login again  to start chatting');
      commit("setSignedIn", false);


      //console.log('verified')


    },



    signOut({ commit }) {

      //console.log("sign out")
      commit("setShowResendEmail", true)
      commit("setAlertMessage", 'You have been signed out');
      commit("setSignedIn", false);


      //console.log('verified')


    },

    async countryExist({ dispatch }, payload) {
      console.log("country Exists module")


      var myCountry = payload
      // myCountry = myCountry.replace(" ", "");
      myCountry = myCountry.replace(".", "");
      myCountry = myCountry.replace("#", "");
      myCountry = myCountry.replace("$", "");
      myCountry = myCountry.replace("[", "");
      myCountry = myCountry.replace("]", "");



      var userCountry = await dispatch('checkUserExists2', myCountry)

      //console.log("Peter", userCountry)
      if (userCountry == "#") {

        //update appstate
        //console.log("Mercy")
        firebase.database().ref('/appState')
          .child(myCountry)
          .set({

            appStateValue: "0"
          }).catch(err => {
            // console.log("error", err)
          });;

        //update appstatistics
        //console.log("James")
        // firebase.database().ref('/appStatistics')
        // .child(myCountry)
        //.set({
        // online: 0,
        // totalMessages: -5
        //}).catch(err => {
        // console.log("error", err)
        // });
      }



    },
    sendVerification({ commit }, payload) {

      var postData = {
        email: payload.email,
        domain: payload.domain,
      };

      Framework7.request.post(
        "https://chatme24.com/penpal/penpalsendVerification.php",
        postData,
        function (data) {
          console.log(data)
          if (data == '0') {

            commit(
              "setAlertMessage",
              `A verification email has been sent to ${payload.email}`
            );
            return
          }


          if (data == '1') {
            commit(
              "setAlertMessage",
              "We cannot find the  email provide. No verification email sent."
            );
          } else {
            commit(
              "setAlertMessage",
              "A verification email cannot be sent now"
            );
          }



        }
      )


    },
  },


};





function getOS() {
  // console.log("getos");
  var userAgent = window.navigator.userAgent,
    platform = window.navigator.platform,
    macosPlatforms = ["Macintosh", "MacIntel", "MacPPC", "Mac68K"],
    windowsPlatforms = ["Win32", "Win64", "Windows", "WinCE"],
    iosPlatforms = ["iPhone", "iPad", "iPod"],
    os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = "Mac OS";
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = "iOS";
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = "Windows";
  } else if (/Android/.test(userAgent)) {
    os = "Android";
  } else if (!os && /Linux/.test(platform)) {
    os = "Linux";
  }

  return os;
}

export default AuthModule;
